// A random per-browser token that proves "this note was written on this
// device" (general notes, C10). The server stores only its SHA-256 hash, so
// only this browser can edit or remove its own notes. Same try/catch-guarded
// pattern as lockToken.ts; separate from the suggestion lock token because
// that one is cooperative and this one gates edits.

const KEY = 'hsp_device_token';
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

let memoryToken: string | null = null;

function randomToken(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  let out = '';
  for (const byte of bytes) out += ALPHABET[byte % ALPHABET.length];
  return out;
}

export function getOrCreateDeviceToken(): string {
  try {
    let token = localStorage.getItem(KEY);
    if (!token) {
      token = randomToken();
      localStorage.setItem(KEY, token);
    }
    return token;
  } catch {
    // Storage blocked: one token for the life of this page, so notes added
    // here can still be edited until a reload.
    memoryToken ??= randomToken();
    return memoryToken;
  }
}
